export interface ITargetProportions {
  item1: number
  item2: number
}

export const checkProportion = (data: ITargetProportions[]) => {
  let result = false

  data.forEach((el) => {
    if (el.item1 !== 0 && el.item2 !== 0) {
      result = result || el.item1 / el.item2 <= 1 / 50 || el.item2 / el.item1 <= 1 / 50
    }
  })

  return !result
}
